import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { clearAdminStorage, getStoredAdminInfo } from "../AdminAuth";

const ADMIN_ROLE_LABEL_MAP = {
  ADMIN: "총학생회 관리자",
  STDCOUNCIL: "총학생회 관리자",
  STANDARD_COUNCIL: "총학생회 관리자",

  AUDIT: "감사위원회 관리자",
  AUDITOR: "감사위원회 관리자",

  CLUB: "동아리연합회 관리자",
  CLUB_UNION: "동아리연합회 관리자",

  SCITECH: "과학기술대학 관리자",
  GLOBAL: "글로벌융합대학 관리자",
  FUTURE: "미래인재대학 관리자",
  PHARM: "약학대학 관리자",
  ARTDESIGN: "아트앤디자인대학 관리자",

  COLLEGE: "중앙운영위원회 관리자",
  CC: "중앙운영위원회 관리자",
};

const HEADER_NAME_LABEL_MAP = {
  총학생회: "총학생회 관리자",
  감사위원회: "감사위원회 관리자",
  동아리연합회: "동아리연합회 관리자",
  과학기술대학: "과학기술대학 관리자",
  글로벌융합대학: "글로벌융합대학 관리자",
  미래인재대학: "미래인재대학 관리자",
  약학대학: "약학대학 관리자",
  아트앤디자인대학: "아트앤디자인대학 관리자",
};

function normalizeAdminLabel(value) {
  if (!value) return "";

  const trimmed = String(value).trim();

  if (!trimmed) return "";

  if (trimmed.endsWith("관리자")) {
    return trimmed;
  }

  return `${trimmed} 관리자`;
}

function getAdminRoleLabel(adminInfo) {
  const {
    role,
    adminType,
    isStdCouncil,
    isCc,
    isAudit,
    headerName,
    adminId,
  } = adminInfo;

  const roleKey = role ? String(role).toUpperCase() : "";
  const adminTypeKey = adminType ? String(adminType).toUpperCase() : "";

  if (HEADER_NAME_LABEL_MAP[headerName]) {
    return HEADER_NAME_LABEL_MAP[headerName];
  }

  if (ADMIN_ROLE_LABEL_MAP[roleKey]) {
    return ADMIN_ROLE_LABEL_MAP[roleKey];
  }

  if (ADMIN_ROLE_LABEL_MAP[adminTypeKey]) {
    return ADMIN_ROLE_LABEL_MAP[adminTypeKey];
  }

  if (isStdCouncil) {
    return "총학생회 관리자";
  }

  if (isAudit) {
    return "감사위원회 관리자";
  }

  if (isCc) {
    return normalizeAdminLabel(headerName || "중앙운영위원회");
  }

  if (headerName) {
    return normalizeAdminLabel(headerName);
  }

  if (adminId) {
    return normalizeAdminLabel(adminId);
  }

  return "관리자";
}

export default function AdminHeader() {
  const location = useLocation();
  const adminInfo = getStoredAdminInfo();
  const { isAudit } = adminInfo;

  const getPageTitle = () => {
    const path = location.pathname;

    if (isAudit) {
      if (path.includes("/data")) return "자료실 관리";
      if (path.includes("/account")) return "내 계정 설정";
      return "감사위원회 관리자 페이지";
    }

    if (path.includes("/intro")) return "소개 관리";
    if (path.includes("/organization")) return "조직도 관리";
    if (path.includes("/contents/notice")) return "공지사항 관리";
    if (path.includes("/contents/event")) return "행사 관리";
    if (path.includes("/contents/partner")) return "제휴·협력 관리";
    if (path.includes("/contents/calendar")) return "달력 관리";
    if (path.includes("/data")) return "자료실 관리";
    if (path.includes("/group")) return "조직별 관리";
    if (path.includes("/site")) return "사이트 관리";
    if (path.includes("/permission")) return "권한 관리";
    if (path.includes("/account")) return "내 계정 설정";

    return "관리자 페이지";
  };

  return (
    <header className="admin-header">
      <h2 className="page-title">{getPageTitle()}</h2>
      <UserDropdown />
    </header>
  );
}

function UserDropdown() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const adminInfo = getStoredAdminInfo();

  const getUserLabel = () => {
    const roleLabel = getAdminRoleLabel(adminInfo);

    if (roleLabel === "관리자") {
      return "안녕하세요, 관리자님";
    }

    return `안녕하세요, ${roleLabel}님`;
  };

  const handleAccountMove = () => {
    setOpen(false);
    navigate("/stdcounciladmin/adminhome/account");
  };

  const handleLogout = () => {
    clearAdminStorage();

    setOpen(false);

    navigate("/stdcounciladmin", {
      replace: true,
    });
  };

  return (
    <div className="user-container">
      <button
        type="button"
        className={`user-toggle ${open ? "is-open" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="user-label">{getUserLabel()}</span>
        <span className="user-arrow" aria-hidden="true" />
      </button>

      {open && (
        <div className="user-dropdown">
          <button
            type="button"
            className="dropdown-item"
            onClick={handleAccountMove}
          >
            내 계정 설정
          </button>

          <button
            type="button"
            className="dropdown-item"
            onClick={handleLogout}
          >
            로그아웃
          </button>
        </div>
      )}
    </div>
  );
}